;(function(){

	var mobile = 1024;

	$('.page-header--video')
		.each(function(){

			var $header = $(this),
				$video = false;

			if( site.width >= mobile ){

				$video = $('<video />', {
						html: '<source src="' + $header.data('video') + '" type="video/mp4">'
					})
					.prop({
						loop: true,
						autoplay: true,
						muted: true
					})
					.appendTo($header)
					.on('play', function(){

						TweenLite
							.to($video, .3, {
								autoAlpha: 1
							});

					});

			}

			$header
				.find('.button[data-video]')
				.on('click', function(){

					var $waves = $header.find('canvas'),
						$iframe = $('<iframe src="//www.youtube.com/embed/' + $(this).data('video') + '?modestbranding=1&amp;autoplay=1&amp;rel=0&amp;showinfo=0" frameborder="0" allowfullscreen></iframe>'),
						$curtain = $('<span/>', {
							'class': 'curtain'
						}).appendTo($header);

					TweenLite
						.fromTo($curtain, .2, {
							opacity: 0
						},{
							opacity: 1,
							onComplete: function(){

								TweenLite
									.set($header.find('.page-header__inner'), {
										autoAlpha: 0
									});

								if( $video )
									$video.remove();

								$iframe.appendTo($header);

							}
						});

				});

		});

}());
